import { useEffect } from "react";

import { Spinner } from "reactstrap";

export default function SpinnerLoading({
  mensagem,
  showMensagemPadrao = false,
  size,
}) {
  return (
    <div className="d-flex justify-content-center mt-2">
      <Spinner size={size} color="dark" />
      {(mensagem || showMensagemPadrao) && (
        <span className="px-2">{mensagem || "Carregando..."}</span>
      )}
    </div>
  );
}

/*
 * Spinner que bloqueia a tela enquanto uma consulta está em andamento,
 * para o usuário não alterar os campos antes do retorno (bloqueia o mouse e o teclado)
 * OBS: Não altera o foco, então o campo que estava com o foco continua com ele ao terminar
 */
export function SpinnerBloqueioTela({ mensagem }) {
  //Bloqueia o teclado enquanto o spinner está na tela
  useEffect(() => {
    function bloquearTecla(event) {
      //Mantém os atalhos do navegador (F5, F12, Ctrl+R...)
      if (
        event.ctrlKey ||
        event.metaKey ||
        event.altKey ||
        /^Fd+$/.test(event.key)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
    }

    document.addEventListener("keydown", bloquearTecla, true);
    return () => document.removeEventListener("keydown", bloquearTecla, true);
  }, []);

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        cursor: "wait",
      }}
    >
      <div className="bg-white border rounded shadow-sm px-4 pb-2 pt-1">
        <SpinnerLoading mensagem={mensagem} showMensagemPadrao={true} />
      </div>
    </div>
  );
}
